import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-subscription-view',
  templateUrl: './subscription-view.component.html',
  styleUrls: ['./subscription-view.component.css']
})
export class SubscriptionViewComponent implements OnInit {

  name:string = '';
  email:string = '';
  constructor(private route: ActivatedRoute, private router: Router) {}

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
       this.name = params['name'];
       this.email = params['email'];
    });
  }

  onUpgrade(){
    this.router.navigate(['/upgrade','Plus'])
  }
}
